import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export const ProjectCard = ({ id, title, imageUrl, year = "2024" }) => {
  const routePath = year === "2025" ? `/projects/2025/${id}` : `/projects/2024/${id}`;

  return (
    <Link
      to={routePath}
      className="relative block rounded-lg overflow-hidden shadow-lg group min-h-[300px] md:min-h-[350px]"
    >
      <div
        className="absolute inset-0 bg-center bg-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
        style={{ backgroundImage: `url(${imageUrl})` }}
        aria-hidden="true"
      ></div>

      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>

      <div className="relative flex flex-col justify-end h-full p-4 md:p-6">
        <h3 className="text-white text-xs md:text-sm font-bold leading-tight">
          {title}
        </h3>
        <span className="text-sm text-blue-300 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          Узнать больше →
        </span>
      </div>
    </Link>
  );
};

ProjectCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  year: PropTypes.string,
};

export default ProjectCard;
